import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { StepResponse, StepRequest, DocumentsResponse } from './def/steps';
import { StepsService } from './steps.service';
import { AdditionalInsuredService } from './additional-insured.service';
import { AvailableEndorsementRequest } from './def/additional-insured';

@Injectable({
  providedIn: 'root'
})
export class AppDataService {
  changeStorage = new Subject();
  logoutMsg = new BehaviorSubject('You have successfully logged out');

  private boundSitecoreData = new BehaviorSubject(null);
  private stepsSitecoreData = new BehaviorSubject(null);
  showSummary = new BehaviorSubject(false);
  stepsSitecoreContent = new Subject();
  summarySitecoreContent = new Subject();
  summaryUpdatedData = new Subject();
  policyData = new Subject<StepResponse>();
  documentsData = new Subject<DocumentsResponse>();
  endorsementForms = new Subject<StepResponse>();
  private checkFormDirty = new BehaviorSubject(false);

  constructor(
    private plocyService: StepsService,
    private AdditionalInsuredService: AdditionalInsuredService
  ) {}

  setIsFormDirty(data) {
    this.checkFormDirty.next(data);
  }
  getIsFormDirty(): Observable<any> {
    return this.checkFormDirty.asObservable();
  }
  setBoundSitecoreData(data) {
    this.boundSitecoreData.next(data);
  }
  getBoundSitecoreData(): Observable<any> {
    return this.boundSitecoreData.asObservable();
  }

  setStepsSitecoreData(data) {
    this.stepsSitecoreData.next(data);
  }
  getStepsSitecoreData(): Observable<any> {
    return this.stepsSitecoreData.asObservable();
  }

  fetchAndPublishPolicyDetails(data: StepRequest) {
    this.plocyService.getPolicyDetails(data).subscribe(res => {
      this.policyData.next(res);
    });
  }
  updatePolicyDetails(data: StepResponse) {
    this.policyData.next(data);
  }
  getPolicyDetails(): Observable<StepResponse> {
    return this.policyData.asObservable();
  }

  //Documents Data
  fetchAndPublishDocumentsDetail(data: StepRequest) {
    this.plocyService.getDocumentsDetail(data).subscribe(res => {
      this.documentsData.next(res);
    });
  }
  updateDocumentsDetail(data: DocumentsResponse) {
    this.documentsData.next(data);
  }
  getDocumentsDetail(): Observable<DocumentsResponse> {
    return this.documentsData.asObservable();
  }

  publishgetEndorsementForms(payload: AvailableEndorsementRequest) {
    this.AdditionalInsuredService.getEndorsementForms(payload).subscribe(
      res => {
        this.endorsementForms.next(res);
      }
    );
  }

  getEndorsementForms(): Observable<StepResponse> {
    return this.endorsementForms.asObservable();
  }

  requestDataFromPolicyAndDocumentAPI(payload: StepRequest): Observable<any[]> {
    let policy = this.plocyService.getPolicyDetails(payload);
    let documents = this.plocyService.getDocumentsDetail(payload);
    return forkJoin([policy, documents]);
  }
}
